import { Link } from "react-router-dom";

import { IS_STAFF_CONSOLE, STAFF_ROOT_REDIRECT } from "@/appTarget";

/** 404 — same component on both targets, but the destination
 *  + label of the home button is scope-aware. The contractor SPA
 *  goes back to /jobs (the actual landing page); the staff
 *  console goes back to STAFF_ROOT_REDIRECT (currently
 *  /organizations). Avoids the "Back to Jobs" footgun on a host
 *  that doesn't have a /jobs route mounted. */
export function NotFoundPage() {
  const homePath = IS_STAFF_CONSOLE ? STAFF_ROOT_REDIRECT : "/jobs";
  const homeLabel = IS_STAFF_CONSOLE ? "Back to Organizations" : "Back to Jobs";

  return (
    <div className="flex min-h-[40vh] flex-col items-center justify-center text-center">
      <span className="label-mono mb-2">404</span>
      <h1 className="font-mono text-2xl font-bold tracking-tight">That page doesn't exist.</h1>
      <p className="mt-2 text-graphite-soft">Link's likely stale — head back home.</p>
      <Link
        to={homePath}
        className="mt-6 inline-block rounded bg-graphite px-4 py-2 font-mono text-sm font-semibold text-paper transition hover:bg-graphite-soft"
      >
        {homeLabel}
      </Link>
    </div>
  );
}
